<template>
  <div>
    <h1>
      Scan des cartes
      <small>[{{bus.currentStep.display}}]</small>
    </h1>
    <b-row>
      <b-col md="3">
        <b-form-group horizontal label="Filter" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Rechercher" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Effacer</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
      </b-col>
    </b-row>
    <!-- <b-form-checkbox v-model="small">Small</b-form-checkbox>
    <b-form-checkbox v-model="dark">Dark</b-form-checkbox>
    <b-form-checkbox v-model="fixed">Fixed</b-form-checkbox>-->
    <b-table
      hover
      striped
      ref="scanslist"
      :bordered="true"
      :outlined="true"
      :busy.sync="isBusy"
      :small="small"
      :dark="dark"
      :fixed="fixed"
      :foot-clone="true"
      :items="items"
      :filter="filter"
      @filtered="onFiltered"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
    >
      <div slot="table-busy" class="text-center text-danger my-2">
        <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
        <span class="sr-only">Loading...</span>
      </div>
      <template v-slot:cell(kanban_card)="row">
        <b-button class="mr-2"></b-button>
      </template>
      <template v-slot:cell(detail)="row">
        <b-button          size="sm"
          @click="showDetail(row)"
          class="mr-2"
        >{{ row.detailsShowing ? 'Cacher' : 'Afficher'}} le détail </b-button>
      </template>

      <template v-slot:row-details="row">
        <b-card>
          <b-table striped hover :items="detailsItems" :fields="detailsFields">
          </b-table>
           <b-button size="sm" @click="showDetail(row)">Cacher le détail</b-button>
        </b-card>
      </template>

      <template v-slot:cell(remove)="row">
        <b-button size="sm" variant="danger" @click="clickRemove(row.item)" class="mr-2">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </b-button>
      </template>
      <template v-slot:cell(nb_card_in_stock)="row">
        <p>
          {{row.item.nb_card_in_stock}}
          <span style="color:blue">({{row.item.ratio}}%)</span>
          <b-button
            size="sm"
            style="font-size:12px;margin-left:10px;"
            @click="goToCorrectHippo(row)"
            class="mr-2"
            variant="outline-primary"
          >Hippodrome</b-button>
        </p>
      </template>
      <template v-slot:cell(day_since_last_scan)="row">
        <p>{{row.item.day_since_last_scan}} J</p>
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          v-model="currentPage"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import server from '../../api/server.vue'
import { Steps } from '../../core/services/steps.js'
import { bus } from '../../core/utils/bus.js'
import moment from 'moment'

const items = [{ isActive: true, loading: 'Loading' }]

export default {
  name: 'Scankanban',
  data() {
    return {
      bus: bus,
      filter: null,
      currentPage: 1,
      totalRows: 1,
      perPage: 50,
      small: false,
      fixed: false,
      dark: false,
      items: [],
      detailsItems: [],
      isBusy: false,
      timer: null,

      fields: [
        { key: 'created_at', label: 'Scanné le', sortable: true },
        { key: 'kanban_card__card_id', label: 'Carte Kanban', sortable: true },
        { key: 'reference__code', label: 'Référence', sortable: true },
        { key: 'reference__designation', label: 'Désignation', sortable: true },
        { key: 'average_speed', label: 'Moyenne Conso', sortable: true },
        { key: 'andon_speed', label: 'Andon', sortable: true },
        { key: 'nb_card_in_stock', label: 'Cartes en stock', sortable: true },
        {
          key: 'day_since_last_scan',
          label: 'Carte précédente vue il y a',
          sortable: true
        },
        'Detail',
        'remove'
      ],
      detailsFields: [
        { key: 'kanban_card_number', label: 'N° Carte', sortable: false },
        {
          key: 'supplier__supplier',
          label: 'Fournisseur',
          sortable: false
        },
        {
          key: 'kanban_reference__batch_size',
          label: 'Taille de lot',
          sortable: false
        },
        { key: 'emplacement', sortable: false },
        {
          key: 'kanban_reference__rotation',
          label: 'Rotation',
          sortable: false
        },
      ],
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.items = []
    bus.currentStep = Steps[to.params.step]
    this.$refs.scanslist.refresh()
    next()
  },
  methods: {
    // clickRemove(row) {
    //   server.removeScan(row.uniqid).then(result => {
    //     this.getData()
    //   })
    // },
    goToCorrectHippo (row) {
      if (bus.currentStep.name === 'En Préparation' || bus.currentStep.name.includes('Cellule')) {
        this.goTo('/andon_internal/' + row.item.reference__code.replace(/ /g, ''))
      } else {
        this.goTo('/andon/' + row.item.reference__code.replace(/ /g, ''))
      }
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getData () {
      if (!bus.currentStep )
      {
        this.$toasted.error(" Oulala ! Etape inconnue !", {
          theme: "bubble",
          position: "top-center",
          duration : 10000
        });
        this.goTo('/')
      }
      const params = {perPage: this.perPage, currentPage: this.currentPage, filter: this.filter}
      server.getAllScanKanban(bus.currentStep.code, params).then(response => {
        server.getAllKanbanCardRatio().then(result => {
          this.items = response.data.scans

          this.totalRows = response.data.total_scans
          for (var i = 0; i < this.items.length; i++) {
            var elem = 0
            var ratio = 0
            this.items[i]['_cellVariants'] = {}

            this.items[i]['nb_card_in_stock'] =
              result.data.nb_card_in_stock[this.items[i]['reference__code']]
            if (
              this.items[i]['nb_card_in_stock'] === 0 ||
              this.items[i]['nb_card_in_stock'] === undefined
            ) {
              this.items[i]['nb_card_in_stock'] = 0
            }
            ratio =
              (this.items[i]['nb_card_in_stock'] /
                this.items[i]['kanban_reference__nbr_card']) *
              100

            this.items[i]['ratio'] = Math.trunc(ratio)
            this.items[i]['day_since_last_scan'] = Math.trunc(
              this.items[i]['seconds_last_reference'] / 86400
            )
            this.items[i]['created_at'] = moment(
              this.items[i]['created_at']
            ).format('YYYY/MM/DD')
            this.items[i]['average_speed'] =
              (this.items[i]['average_speed'] / 86400).toFixed(2) + ' J'
            if (this.items[i]['ratio'] <= 30) {
              this.items[i]['_cellVariants']['nb_card_in_stock'] = 'danger'
            }
            if (this.items[i]['andon_speed'] == 'standard') {
              this.items[i]['andon_speed'] = ''
            }
            if (this.items[i]['andon_speed'] == 'fast') {
              this.items[i]['_cellVariants']['average_speed'] = 'danger'
              this.items[i]['_cellVariants']['andon_speed'] = 'danger'
              this.items[i]['andon_speed'] = 'ACCELERATION'
            } else if (this.items[i]['andon_speed'] == 'slow') {
              this.items[i]['_cellVariants']['average_speed'] = 'warning'
              this.items[i]['_cellVariants']['andon_speed'] = 'warning'
              this.items[i]['andon_speed'] = 'RALENTISSEMENT'
            }
            if (this.items[i]['kanban_reference__rotation'] < 4) {
              this.items[i]['_cellVariants']['kanban_reference__rotation'] =
                'danger'
            }
            if (this.items[i]['reference__code'].length != 9) {
              this.items[i]['_cellVariants']['reference__code'] = 'danger'
            }
            if (this.items[i]['kanban_card__card_id'].length != 6) {
              this.items[i]['_cellVariants']['kanban_card__card_id'] = 'danger'
            }
            this.items[i]['reference__code'] = this.chunk(this.items[i]['reference__code'], 3)
          }
          this.isBusy = false
          this.setProtectedTimeout(this.getData, 5000)

        })
      })
    },
    showDetail (row) {
        this.detailsItems.length = 0
        var zone = row.item.reference__zone
        if (!zone) zone = '?'

        this.detailsItems.push({
          "kanban_card_number":
              row.item.kanban_card__card_index +
              ' / ' +
              row.item.kanban_reference__nbr_card,
          "supplier__supplier": row.item.supplier__supplier,
          "kanban_reference__batch_size": row.item.kanban_reference__batch_size,
          "emplacement":
              zone +
              row.item.reference__pos_y +
              " " +
              ("0" + row.item.reference__pos_x).slice(-2) +
              " " +
              row.item.reference__pos_z,
          "kanban_reference__rotation": row.item.kanban_reference__rotation
        })
      row.toggleDetails()
    },
  },
  watch: {
    filter (val) {
      if (this.filter) {
        this.$router.push({ name: 'scankanban', params: { filter: val } })
      }
    }
  },
  mounted: function() {
    bus.currentStep = Steps[this.$route.params.step]
    this.filter = this.$route.params.filter
    this.getData()

    // if (window.localStorage.getItem('isAdmin') !== 'ADMIN') {
    //   this.fields.pop()
    // }

  }

}
</script>



// WEBPACK FOOTER //
// src/components/andon/scans.vue